// Persistierte manuelle Kartenreihenfolge fuer DATENGETRIEBENE Card-Grids
// (Sensoren, Aktoren, ...). Anders als Dashboards ZONE_DEFAULTS ist die
// Menge der IDs hier nicht statisch, sondern kommt aus dem Summary-Store:
// Default = die vom Server gelieferte Reihenfolge, der gespeicherte Stand
// wird damit gemerged (unbekannte/verschwundene IDs raus, neu aufgetauchte
// hinten dran). So ueberlebt der Stand das Kommen/Gehen von Geraeten.
//
// Persistenz laeuft ueber den prefs-Store (Server-SSOT + WS-Sync), analog
// zur Dashboard-Zonenanordnung. Gedraggt wird per use:pressReorder; diese
// Helfer liefern nur die Sortierung + das Umschreiben der Reihenfolge.

import { getPref, setPref } from "./prefs.svelte";

function key(group: string): string {
  return `card_order_${group}`;
}

// Sortiert items nach gespeicherter Reihenfolge. Ohne gespeicherten Stand
// bleibt die Eingangsreihenfolge. Bekannte IDs nach ihrem Rang, neue (nicht
// gespeicherte) behalten ihre relative Eingangsreihenfolge und landen
// hinter allen bekannten. Reaktiv, weil getPref den SvelteMap liest.
export function orderItems<T>(
  group: string,
  items: T[],
  idOf: (item: T) => string,
): T[] {
  const saved = getPref<string[]>(key(group));
  if (!saved || saved.length === 0) return items;
  const rank = new Map(saved.map((id, i) => [id, i]));
  const base = saved.length;
  return items
    .map((item, i) => ({ item, i }))
    .sort((a, b) => {
      const ra = rank.get(idOf(a.item)) ?? base + a.i;
      const rb = rank.get(idOf(b.item)) ?? base + b.i;
      return ra - rb;
    })
    .map((x) => x.item);
}

// Verschiebt fromId an die Position von toId (Einfuege-Modell) und
// persistiert die neue Reihenfolge. currentIds = die aktuelle, bereits
// sortierte ID-Liste der Gruppe (so bleibt der gespeicherte Stand
// vollstaendig, auch fuer IDs die noch nie gedraggt wurden).
export function moveCard(
  group: string,
  currentIds: string[],
  fromId: string,
  toId: string,
): void {
  const cur = [...currentIds];
  const fi = cur.indexOf(fromId);
  const ti = cur.indexOf(toId);
  if (fi < 0 || ti < 0 || fi === ti) return;
  cur.splice(fi, 1);
  cur.splice(ti, 0, fromId);
  setPref(key(group), cur);
}

// Setzt eine Gruppe auf die Server-Default-Reihenfolge zurueck.
export function resetCardOrder(group: string): void {
  setPref(key(group), null);
}
